module.exports = __webpack_public_path__ + "static/img/about_introduce_01_zh_h5_1.a8ed9c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_introduce_01_zh_h5_1.png
// module id = YVLZ
// module chunks = 34